module.exports = __webpack_public_path__ + "static/tableau-f7611e74c0f8d25bb2c322e134746f1e.png";